"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WirelessInsuranceState = void 0;
var WirelessInsuranceState = /** @class */ (function () {
    function WirelessInsuranceState() {
        this.isExpandedView = false;
    }
    return WirelessInsuranceState;
}());
exports.WirelessInsuranceState = WirelessInsuranceState;
//# sourceMappingURL=WirelessInsuranceState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessInsurance/WirelessInsuranceState.js
// module id = 2303
// module chunks = 8